const VERSION = '3.12.6';
export default VERSION;
